import { AgTechClickEventHandler, AgTechButtonProps, AgTechButton } from "@agtech/web/components/Buttons/AgTechButtons"
import AgTechLeftPaneTabPage from "@agtech/web/components/Pages/Tabbed/Flavors/AgTechLeftPaneTabPage"
import AgTechTourHelpButton from "@agtech/web/components/App/Tour/AgTechTourHelpButton"
import LotCategorySettingsPage from "../../lotCategories/pages/LotCategorySettingsPage"
import TaskTemplateSettingsPage from "../../taskTemplates/pages/TaskTemplateSettingsPage"
import AgTechViewDialog from "@agtech/web/components/Portals/Dialogs/AgTechViewDialog"
import SaleInvoiceModifierViewGrid from "../../invoicemodifiers/components/grids/SaleInvoiceModifierViewGrid"
import LogoUpdateForm from "@agtech/web/integrations/operation/logo/forms/OperationLogoUpdateForm"
import DocumentHeaderConfigurationPage from "../pages/DocumentHeaderConfigurationPage"
import InvoiceDocumentConfigurationPage from "../pages/InvoiceDocumentConfigurationPage"
import { getSaleSettingsViewDialogTourConfig } from "./SaleSettingsViewDialogTourConfig"
import { useHasPermission } from "@agtech/web/components/App/Auth/AgTechWebAuthContext"
import TeamRolesTab from "./settings/TeamRolesTab"
import { getSaleSettingsTabTourConfigs } from "./SaleSettingsTabTourConfigs"

const SaleSettingsViewDialog = () => {
    const canViewTeam = useHasPermission('operation.users.view');

    return (
        <AgTechViewDialog
            structure={{
                header: () => ({
                    header: 'My Sale Settings',
                    detail: 'Use the options below to configure common settings across your sales',
                    settings: {
                        content: {
                            body: () => <AgTechTourHelpButton tourConfig={getSaleSettingsViewDialogTourConfig({ includeTeamTab: canViewTeam })} />
                        }
                    }
                }),
                width: '1100px',
            }}
        >
            {() => (
                <AgTechLeftPaneTabPage
                    tabTourConfigs={getSaleSettingsTabTourConfigs()}
                    tabGroups={[
                        {
                            header: 'Sales',
                            tabs: [
                                { id: 'sale-settings-lot-categories-tab', text: 'Lot Categories', content: () => <LotCategorySettingsPage />},
                                { id: 'sale-settings-charges-discounts-tab', text: 'Charges and discounts', content: () => <div id='settings-modifiers-page' className='stretched row-based container'><SaleInvoiceModifierViewGrid /></div>},
                                { id: 'sale-settings-task-templates-tab', text: 'Task Templates', content: () => <TaskTemplateSettingsPage />}
                            ]
                        },
                        {
                            header: 'Documents',
                            tabs: [
                                { id: 'sale-settings-document-headers-tab', text: 'Document Headers', content: () => <DocumentHeaderConfigurationPage />},
                                { id: 'sale-settings-invoice-fields-tab', text: 'Invoice Fields', content: () => <InvoiceDocumentConfigurationPage />},
                            ]
                        },
                        {
                            header: 'Operation',
                            tabs: [
                                { id: 'sale-settings-logo-tab', text: 'Logo', content: () => <LogoUpdateForm />},
                                ...(canViewTeam ? [{ id: 'sale-settings-team-tab', text: 'Team', content: () => <TeamRolesTab /> }] : [])
                            ]
                        },
                    ]}
                />
            )}
        </AgTechViewDialog>
    )
}

SaleSettingsViewDialog.ButtonProps = {
    text: 'Update Sale Settings',
    icon: 'fas fa-cog',
    action: (e: AgTechClickEventHandler) => e.dialogs.openDialog({
        dialog: () => <SaleSettingsViewDialog />
    })
}

SaleSettingsViewDialog.Button = (props: AgTechButtonProps) => (
    <AgTechButton
        {...SaleSettingsViewDialog.ButtonProps}
        {...props}
    />
)

export default SaleSettingsViewDialog